import { render } from "./loginView.vue?vue&type=template&id=39bc202a"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__